import React from "react"

const StaffLayout = ({ children }) => {
  return <div>{children}</div>
}

export default StaffLayout
